import { useEffect } from 'react';

import type { MapMouseEvent, UsePickPointParams } from './types';

// Attaches a dedicated `map.on('click', ...)` listener that bypasses the
// existing `useClick.handleMapClick` pipeline. The Flight Planner uses
// `hasDrawingControls: false`, which short-circuits `useClick`'s early return
// — that's why pick mode needs its own listener. See Decision 43.
//
// StrictMode note: the effect is stateless. React 18's double-invoke runs
// mount → cleanup → remount, which simply detaches then re-attaches the same
// listener. No refs or latched state to reset (Decision 20 N/A here).
const usePickPoint = ({ map, onPickPoint }: UsePickPointParams) => {
    useEffect(() => {
        if (!map || !onPickPoint) {
            return;
        }

        const handleClick = (event: MapMouseEvent) => {
            onPickPoint({ lat: event.lngLat.lat, lon: event.lngLat.lng });
        };

        map.on('click', handleClick);

        return () => {
            map.off('click', handleClick);
        };
    }, [map, onPickPoint]);
};

export default usePickPoint;
